import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { ServiceColumnContainer } from '../../../containers/service-column-container';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const ServiceColumn = ({ fulfillmentId }) => {
  const { labelFulfillment } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};

  const { serviceId } = labelFulfillment;

  return <ServiceColumnContainer serviceId={serviceId} />;
};

ServiceColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const Service = {
  getMessageDescriptor: () => messages.service,
  id: 'service',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <ServiceColumn fulfillmentId={data.id} />;
  },
};
